'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _certificates = require('./certificates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.certificates', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('general.certificates', {
        url: '/certificates?page&pageSize&identification',
        views: {
            'main@root': {
                component: 'certificates'
            }
        },
        reloadOnSearch: false,
        params: {
            loadingOverlay: false,
            page: {
                value: '1',
                squash: true
            },
            pageSize: {
                value: window.localStorage.getItem('pageSize'),
                squash: true
            },
            identification: {
                value: '',
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"Certificates" | translate}}'
        }
    }).state('root-certificaten', {
        parent: 'root',
        url: '/certificaten',
        onEnter: ["$state", function onEnter($state) {
            var language = 'nl';

            return $state.target('general.certificates', Object.assign({}, $state.transition.params('to'), {
                language: language
            }));
        }]
    }).state('root-certificats', {
        parent: 'root',
        url: '/certificats',
        onEnter: ["$state", function onEnter($state) {
            var language = 'fr';

            return $state.target('general.certificates', Object.assign({}, $state.transition.params('to'), {
                language: language
            }));
        }]
    }).state('general-certificaten', {
        parent: 'general',
        url: '/certificaten',
        redirectTo: 'general.certificates'
    }).state('general-certificats', {
        parent: 'general',
        url: '/certificats',
        redirectTo: 'general.certificates'
    });
}]).component('certificates', _certificates.certificatesComponent);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./features/certificates/index.js
// module id = 902
// module chunks = 0